import styled from 'styled-components';

import { BrandXXS } from '@sorare/core/src/atoms/typography';
import { absCenter, unitMapping, type Unit } from '@sorare/core/src/lib/style';

const Root = styled.div`
  position: relative;
`;
const ThresholdStep = styled.div`
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%);
`;
const Svg = styled.svg`
  ${absCenter}
`;
const StyledBrandXXS = styled(BrandXXS)`
  text-shadow: 0 0 3.713px #000;
  font-size: 10px;
`;

type Props = {
  size?: Unit;
  currentStreakToDisplay?: number;
  additionalLineupReward?: boolean;
};
export const ThresholdIcon = ({
  size = 2,
  currentStreakToDisplay,
  additionalLineupReward,
}: Props) => {
  return (
    <Root style={{ width: unitMapping[size], height: unitMapping[size] }}>
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox={additionalLineupReward ? '0 0 12 16' : '0 0 16 16'}
        fill="none"
        style={{ width: unitMapping[size], height: unitMapping[size] }}
      >
        {additionalLineupReward ? (
          <>
            <path
              d="M9.0293 6.3623L9.17676 6.51562H10.1904V5.62598L11.9355 7.74902V12.0361L8.81738 15.0381L7.6709 10.624L7.57422 10.25H4.79199L4.6875 10.6113L3.38477 15.1201L0.5 12.3135V4.8584L2.89746 6.6543L3.03027 6.75391H4.09473V1.23926L9.0293 6.3623Z"
              stroke="url(#paint0_linear_28638_8972)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_28638_8972"
                x1="11.2572"
                y1="18"
                x2="3.46413"
                y2="9.8916"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FEF314" />
                <stop offset="1" stopColor="#FF4E22" />
              </linearGradient>
            </defs>
          </>
        ) : (
          <>
            <path
              d="M11.3896 6.01516H11.6882H11.69V4.22909L14.4354 7.56981V12.2487L10.5497 15.9907L9.18731 10.75H7.16794L5.65249 16H5.57224L2.00009 12.5249V3.85956L5.19711 6.25405H5.59463V0L11.3896 6.01516Z"
              fill="url(#paint0_linear_27767_142806)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_27767_142806"
                x1="13.2573"
                y1="18"
                x2="5.46423"
                y2="9.8916"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#FEF314" />
                <stop offset="1" stopColor="#FF4E22" />
              </linearGradient>
            </defs>
          </>
        )}
      </Svg>
      {!!currentStreakToDisplay && (
        <ThresholdStep>
          <StyledBrandXXS>{currentStreakToDisplay}</StyledBrandXXS>
        </ThresholdStep>
      )}
    </Root>
  );
};
